<script>
import {
  infoMethods,
  infoDetailsMethods,
  deviceProductivityMethods,
  filtersComputed,
} from '@state/helpers'

export default {
  components: {},

  props: {
    device: {
      type: Object,
      default: () => {},
    },

    cycle: {
      type: Object,
      default: () => {},
    },

    showLabels: {
      type: Boolean,
      default: () => true,
    },
  },

  data: () => {
    return {
      productivity: null,
    }
  },

  computed: {
    ...filtersComputed,
  },

  watch: {
    dateRangeWebFilters() {
      this.getDeviceProductivity({
        deviceId: this.device.id,
        dateRange: this.dateRangeWebFilters,
      }).then((response) => {
        this.productivity = response
      })
    },
  },

  created: function() {
    this.getDeviceProductivity({
      deviceId: this.device.id,
      dateRange: this.dateRangeWebFilters,
    }).then((response) => {
      this.productivity = response
    })
  },

  methods: {
    ...infoMethods,
    ...infoDetailsMethods,
    ...deviceProductivityMethods,

    setNavigateDetails: function(deviceName, deviceId) {
      this.$router.push({
        name: 'Device State History Detail',
        params: { deviceName: deviceName, deviceId: deviceId },
      })
    },
  },
}
</script>

<template>
  <b-row v-if="productivity" class="ml-0 mr-0 p-0">
    <b-col class="col-4 font-xl m-0 text-uppercase text-left pl-3 "
      ><h5>
        <span class="clearfix">
          {{ !isNaN(productivity.performance) ? productivity.performance : 0 }}%</span
        >
        <span class="font-xs p-0 text-muted clearfix overflow-normal"> Productivity</span>
      </h5>
    </b-col>

    <b-col class="col-4 font-xl m-0 pl-2 text-uppercase text-left">
      <h5>
        <span class="clearfix">
          {{ !isNaN(productivity.availability) ? productivity.availability : 0 }}%</span
        >
        <span class="font-xs p-0 text-muted clearfix overflow-normal"> Availability</span>
      </h5>
    </b-col>

    <b-col class="col-4 font-xl m-0 text-uppercase text-right">
      <h5>
        <span v-if="cycle != null" class="clearfix">
          {{ cycle.count }}
          <span v-if="cycle.total" class="text-muted">/ {{ cycle.total }}</span></span
        >
        <span v-else class="clearfix">
          --
        </span>
        <span class="font-xs p-0 text-muted clearfix overflow-normal  "> Count</span>
      </h5>
    </b-col>
  </b-row>

  <b-row v-else class="ml-0 mr-0">
    <b-col class="col-4 font-xl m-0 text-uppercase text-left pl-3 "
      ><h5>
        <span class="clearfix"> - - </span>
        <span class="font-xs p-0 text-muted clearfix overflow-normal"> Productivity</span>
      </h5>
    </b-col>

    <b-col class="col-4 font-xl m-0 pl-0 text-uppercase text-left">
      <h5>
        <span class="clearfix"> - - </span>
        <span class="font-xs p-0 text-muted clearfix overflow-normal"> Availability</span>
      </h5>
    </b-col>

    <b-col class="col-4 font-xl m-0 text-uppercase text-right">
      <h5>
        <span class="clearfix"> - - <span class="text-muted"></span></span>
        <span class="font-xs p-0 text-muted clearfix overflow-normal  "> Count</span>
      </h5>
    </b-col>
  </b-row>
</template>
